import { Namespace, TFunction } from 'react-i18next';

import { BaseOption } from 'components/forms/multiSelectField/MultiSelectField.types';
import Tooltip from 'components/tooltip/Tooltip';
import { getRecipientUidAndTypeFromValue } from '../TriggersTab.utils';

export const formatRecipientOptionLabel = (
  option: BaseOption,
  t: TFunction<Namespace<'en'>>,
) => {
  if (!option.disabled) {
    return option.label;
  }

  const { type } = getRecipientUidAndTypeFromValue(option.value);

  return (
    <Tooltip
      id={`recipientList-${type}`}
      text={t('pageAutomations.triggers.recipientTypeDisabledTooltip', {
        context: type,
      })}
    >
      {option.label}
    </Tooltip>
  );
};
